import { render } from "./allProduct.vue?vue&type=template&id=5766fc00&scoped=true"
import script from "./allProduct.vue?vue&type=script&lang=js"
export * from "./allProduct.vue?vue&type=script&lang=js"

import "./allProduct.vue?vue&type=style&index=0&id=5766fc00&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5766fc00"]])

export default __exports__